var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { attrs: { "data-id": _vm.pharmacist._id } }, [
    _c(
      "td",
      [
        _c("a", { attrs: { href: `/pharmacists/${_vm.pharmacist._id}` } }, [
          _vm._v(_vm._s(_vm.pharmacist.name)),
        ]),
        _vm._v(" "),
        !_vm.pharmacist.active
          ? _c(
              "v-chip",
              { attrs: { color: "secondary lighten-2", "x-small": "" } },
              [
                _c(
                  "v-icon",
                  { staticClass: "mr-1", attrs: { "x-small": "" } },
                  [_vm._v("mdi-eye-off")]
                ),
                _vm._v(" Inaktiv\n        "),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "v-application" }, [
          _c("span", { staticClass: "caption" }, [
            _vm._v(
              _vm._s(_vm.pharmacist.email) +
                " , " +
                _vm._s(_vm.pharmacist.phone)
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("preference-chip", {
          attrs: {
            favorite: _vm.pharmacist.favorite,
            blacklisted: _vm.pharmacist.blacklisted,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _c(
        "span",
        { staticClass: "v-application" },
        _vm._l(_vm.pharmacist.services, function (service) {
          return _c(
            "v-chip",
            {
              staticClass: "mr-1 px-2",
              attrs: {
                color: _vm.renderServiceColor(service),
                dark: "",
                "x-small": "",
                label: "",
              },
            },
            [
              _c("b", [
                _vm._v(
                  _vm._s(
                    service == "substitution"
                      ? "Apotheker/in"
                      : service.toUpperCase()
                  )
                ),
              ]),
            ]
          )
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(_vm.pharmacist.address) + " (" + _vm._s(_vm.distance) + ")"
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.$formatDate(_vm.pharmacist.created_at)))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }